<template>
    <div class="Note">
        <!-- s: header -->
        <header id="header-slidePanel">
            <h2>쪽지</h2>
            <div class="btn_back">
                <a @click="slidePanelClose('close')">
                    <img src="@/assets/images/btn_close.png" width="50" alt="이전" />
                </a>
            </div>
        </header>
        <!-- e: header -->
        <!-- s: contents -->
        <div class="contents-area-slidePanel">
            <h2 class="slidePanel-title clearfix">
                <div class="tab-menu pull-left width-85">
                    <ul>
                        <li :class="noteTab == 'receive' ? 'active' : ''">
                            <a @click="noteTab='receive'">
                                받은쪽지
                            </a>
                        </li>
                        <li :class="noteTab == 'send' ? 'active' : ''">
                            <a @click="noteTab='send', noteChkAll=false, noteChk=[]">
                                보낸쪽지
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="checkbox-list pull-right pdd-right-5">
                    <span>
                        <label class="ckb square">
                            <input type="checkbox"
                                   v-model="noteChkAll"
                                   @change="noteChkAllFunc()" />
                            <i></i>
                        </label>
                    </span>
                </div>
            </h2>
            <div>
                <ul class="li-bottom-line">
                    <li class="clearfix" v-for="(data, index) in list.arrMessage" :key="index">
                        <!-- 받은쪽지 -->
                        <template v-if="noteTab == 'receive'">
                            <div class="pull-left width-85"
                                 @click="noteViewSlideView(noteTab,data.nReceiveMessageNum)">
                                <span>
                                    <strong>{{ data.strSendNickName }}</strong>
                                    {{ data.strRegDate }}
                                </span>
                                <h2>{{ data.strMessage }}</h2>
                            </div>
                            <div class="checkbox-list pull-right">
                                <span>
                                    <label class="ckb square">
                                        <input type="checkbox"
                                               v-model="noteChk"
                                               :value="data.nReceiveMessageNum"
                                               @change="noteChkFunc('agreeChk2')" />
                                        <i></i>
                                    </label>
                                </span>
                            </div>
                        </template>
                        <!-- 보낸쪽지 -->
                        <template v-else>
                            <div class="pull-left width-85" @click="noteViewSlideView(noteTab,data.nSendMessageNum)">
                                <span>
                                    <strong>{{ data.strNickName }}</strong>
                                    {{ data.strRegDate }}
                                </span>
                                <h2>{{ data.strMessage }}</h2>
                            </div>
                            <div class="checkbox-list pull-right">
                                <span>
                                    <label class="ckb square">
                                        <input type="checkbox"
                                               v-model="noteChk"
                                               :value="data.nSendMessageNum"
                                               @change="noteChkFunc('agreeChk2')" />
                                        <i></i>
                                    </label>
                                </span>
                            </div>
                        </template>
                    </li>
                </ul>
            </div>
            <div class="text-center mrg-top-20" v-if="list.arrMessage.length>0">
                <paginate v-model="page"
                          :page-count="totalPage"
                          :prev-text="'<'"
                          :next-text="'>'"
                          :containerClass="'pagination'"
                          :click-handler="changePage">
                </paginate>
                <button class="btn-delete ir"
                        @click="deleteNoteMessageAllFunc">
                    삭제
                </button>
            </div>
        </div>
        <!-- e: contents -->
    </div>
</template>

<script>
import Paginate from 'vuejs-paginate'
import {MessageBox} from "mint-ui";

export default {
    name: 'Note',
    components: { Paginate },
    data() {
        return {
            noteTab:'receive',      // 선택된 Tab
            list:{                  // 쪽지 리스트
                arrMessage:[]
            },
            page:1,                 // 페이지
            totalPage:1,            // 전체페이지
            noteChkAll:false,       // 전체 체크박스
            noteChk:[],             // 개별 체크박스
        }
    },
    // 감시자
    watch: {
        // tab 변경
        noteTab(){
            this.noteChkAll=false;
            this.noteChk=[];
            this.page = 1;
            this.list= {arrMessage:[]};
            // 쪽지
            this.getMessageList(this.page);
        }
    },
    // $el 생성전
    created(){
    },
    // $el 생성후
    mounted() {
        window.callbackBackKey = this.callbackBackKey;
        this.getMessageList(this.page);
    },
    methods: {
        // APP 뒤로가기
        callbackBackKey(){
            this.slidePanelClose();
        },
        // 전체선택
        noteChkAllFunc(){
            let messageNum = (this.noteTab == 'receive') ? 'nReceiveMessageNum' : 'nSendMessageNum';
            if (this.noteChkAll){
                let vm = this;
                this.list.arrMessage.forEach(function (item) {
                    let idx = vm.noteChk.findIndex(function(data) {return data === item[messageNum]});
                    if (idx == -1) vm.noteChk.push(item[messageNum]);
                });
            }else{
                this.noteChk = [];
            }
        },
        // 개별선택
        noteChkFunc(){
            if (this.noteChk.length == this.list.arrMessage.length){
                this.noteChkAll = true;
            }else{
                this.noteChkAll = false;
            }
        },
        // 쪽지 발송후 새로고침
        sendReload(noteTab){
            this.noteTab = noteTab;
            this.noteChkAll=false;
            this.noteChk=[];
            this.page = 1;
            this.list={arrMessage:[]};
            this.getMessageList(this.page);
        },
        // 쪽지
        getMessageList(page){
            this.page = page;
            let param = {};
            this.ajaxGetAuth('/api/v1/message/'+this.noteTab+'/list/'+page, param, this.getMessageListResult);
        },
        // 쪽지 결과
        getMessageListResult(response){
            if (response.result.code == 0){
                if (response.oMessageInfo.arrMessage == null){
                    this.list={arrMessage:[]};
                }else{
                    this.list = response.oMessageInfo;
                }

                this.totalPage=response.oMessageInfo.setting.nMaxPage;
            }else{
                this.toastMsg(response.result.resultNoti.message,1500);
            }
        },
        // 페이지 변경
        changePage(page){
            this.noteChkAll=false;
            this.noteChk=[];
            this.getMessageList(page)
        },
        // 쪽지 삭제
        deleteNoteMessageAllFunc(){
            if (this.noteChk.length == 0){
                this.mintAlert('삭제할 쪽지를 체크해주세요.');
                return false;
            }

            MessageBox({
                title: '',
                message: this.noteTab == 'receive' ? '받은 쪽지를 삭제하시겠습니까?' : '보낸 쪽지를 삭제하시겠습니까?',
                showCancelButton:true,
                cancelButtonText: '취소',
                confirmButtonText: '확인'
            }).then(action => {
                if (action == 'confirm'){
                    let formData = new FormData();
                    formData.append('strMessageNums', this.noteChk);
                    this.ajaxPostAuth('/api/v1/message/'+this.noteTab+'/list/delete', formData,this.deleteNoteMessageAllFuncResult);
                }
            })
        },
        // 쪽지 삭제 결과
        deleteNoteMessageAllFuncResult(response){
            let result = response.result;
            if (result.code == 0){
                this.noteChkAll=false;
                this.noteChk=[];
                this.page = 1;
                this.list={arrMessage:[]};
                this.getMessageList(this.page);
            }else{
                if (result.resultNoti.type == 'alert'){
                    this.toastMsg(result.resultNoti.message, 1500)
                }else{
                    this.errorMsg=result.resultNoti.message;
                    this.errorField=result.resultNoti.validationFail.id;
                }
            }
        },
    }
}
</script>
<style scoped>
    .li-bottom-line li{}
    .li-bottom-line li div{}
    .li-bottom-line li div span{font-size: 13px; font-weight: 400; color: #737373; }
    .li-bottom-line li div span strong{color: #017ff0}
    .li-bottom-line li div h2{font-size: 16px; font-weight: 500; color: #000;text-decoration: none;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;}
    .li-bottom-line li div.read span{color: #a3a3a3; }
    .li-bottom-line li div.read span strong{color: #74abf5}
    .li-bottom-line li div.read h2{color: #a3a3a3;}
    .li-bottom-line li div.checkbox-list {padding-top: 20px;padding-right: 5px;}
    .btn-delete {float: right;margin-top: 10px;}
</style>
